const getColors = (usedColors: string[]) => {
    let color_palette: string[] = [];
    for (let c = 0; c < 100; c++) {
        let getC = "#" + Math.floor(Math.random() * 16777215).toString(16);
        if (!usedColors.includes(getC) && !color_palette.includes(getC)) {
            color_palette.push(getC);
        }
    }
    return color_palette;
};

export default getColors;
